import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Divider} from "@material-ui/core";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {RadioButton} from "primereact/radiobutton";
import {ADDRESS_BY_ACCOUNT,
    ADDRESS_BY_INSTITUTION} from "../../../../utils/constants/Constants"
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditInstitutionInvoiceView = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    {props.messagesGrowl}
                    <Grid item xs={8}>
                        <TitlePage title="Administración \ Facturación \ Editar Institución"/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: "right"}}>
                        <Button label="Regresar"
                                onClick={props.returnEditParameters}
                                className="p-button-secondary"/>&nbsp;
                        <Button label="Guardar"
                                onClick={props.saveAllAddress}/>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Institución" isBold={true}/>
                        <SubtitleLabel header={props.institutionData.NomCorto} />
                    </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Tipo Facturación" isBold={true}/>
                        <RadioButton inputId="institution" name="IdTipo" value={ADDRESS_BY_INSTITUTION}
                                     checked={props.institutionData.IdTipo === ADDRESS_BY_INSTITUTION}
                                     onChange={props.onChangeRadio}/>
                        <label htmlFor="diaria" className="p-radiobutton-label secondary-text">Por Institución</label>
                        &nbsp;&nbsp;
                        <RadioButton inputId="account" name="IdTipo" value={ADDRESS_BY_ACCOUNT}
                                     checked={props.institutionData.IdTipo === ADDRESS_BY_ACCOUNT}
                                     onChange={props.onChangeRadio}/>
                        <label htmlFor="semanal" className="p-radiobutton-label secondary-text">Por Cuenta</label>
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="Dirección" isBold={true}/>
                    </Grid>
                    <Grid item xs={6} style={{textAlign: "right"}}>
                        <Button label="Agregar"
                                className="p-button-secondary"
                                onClick={() => props.redirectUpdateAddress("", true)}
                                disabled={props.disabledAddButton}/>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            value={props.institutionAddresses}
                            selectionMode={"single"}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            onSelectionChange={props.handleSelectedRow}>
                            <Column
                                field="Cuenta"
                                header="Cuenta"
                                style={{textAlign: 'left'}} sortable={true}/>
                            <Column
                                field="RFC"
                                header="RFC"
                                style={{textAlign: 'left'}} sortable={true}/>
                            <Column
                                field="Dir"
                                header="Dirección"
                                style={{textAlign: 'left'}} sortable={true}/>
                            <Column
                                field="Colonia"
                                header="Colonia"
                                style={{textAlign: 'left'}} sortable={true}/>
                            <Column
                                field="CP"
                                header="CP"
                                style={{textAlign: 'left'}} sortable={true}/>
                            <Column
                                field="Cd"
                                header="Ciudad"
                                style={{textAlign: 'left'}} sortable={true}/>
                            <Column
                                header="Acciones"
                                style={{textAlign: 'center'}}
                                body={props.institutionInvoiceActionTemplate}
                            />
                        </DataTable>
                    </Grid>
                    {props.confirmationMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default EditInstitutionInvoiceView;